<template>
  <div :class="ie ? 'partners ie' : 'partners'">
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <img src="@/assets/img/partners-1.png" />
        </div>
        <div class="swiper-slide">
          <img src="@/assets/img/partners-2.jpg" />
        </div>
        <div class="swiper-slide">
          <img src="@/assets/img/partners-3.png" />
        </div>
        <div class="swiper-slide">
          <img src="@/assets/img/partners-4.png" />
        </div>
        <div class="swiper-slide">
          <img src="@/assets/img/partners-5.png" />
        </div>
        <div class="swiper-slide">
          <img src="@/assets/img/partners-6.png" />
        </div>
        <div class="swiper-slide">
          <img src="@/assets/img/partners-7.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Partners',
  props: {
    ie: {
      default: () => false,
      type: Boolean
    }
  }
}
</script>
